import { buildQueryContext, QueryFormData } from '@superset-ui/core';

// basic

export default function buildQuery(formData: QueryFormData) {
  // const { metric, sort_by_metric } = formData;
  return buildQueryContext(formData, baseQueryObject => [
    {
      ...baseQueryObject,
      // ...(sort_by_metric && { orderby: [[metric, false]] }),
    },
  ]);
}